module.exports = __webpack_public_path__ + "static/img/empty.2bfdaae2.png";